import firebase from 'firebase/app';
import 'firebase/storage';
import 'firebase/firestore';

// Your web app's Firebase configuration
var firebaseConfig = {
    apiKey: "AIzaSyDD3TfIpRcYf5f6fjfAFtGLCdNP1dcVxWc",
    authDomain: "trashapp-a04a3.firebaseapp.com",
    projectId: "trashapp-a04a3",
    storageBucket: "trashapp-a04a3.appspot.com",
    messagingSenderId: "94265543829",
    appId: "1:94265543829:web:90bad3be9290e2acd3df9c"
};
// Initialize Firebase
if (!firebase.apps.length) {
    firebase.initializeApp(firebaseConfig)
  }

const projectStorage = firebase.storage();
const projectFirestore = firebase.firestore();
const timestamp = firebase.firestore.FieldValue.serverTimestamp;

export { projectStorage, projectFirestore, timestamp }